import { NOTIFICATION_TYPES } from 'src/consumer/constants'
import { buildBookedEventNotificationData } from './bookedEventNotificationHandlers/bookings-notification-data-injector'
import { buildFallBackNotificationData } from './fallBackNotificationHandlers/fallback-notification-data-injector'
import { activityPlanFallBackNotificationData } from './activityPlanNotificationHandlers/activity-plan-notification-data-injector'

const notificationTypesToDataInjectors = {
  [NOTIFICATION_TYPES.bookedEventNotification]: buildBookedEventNotificationData,
  [NOTIFICATION_TYPES.activityPlan]: activityPlanFallBackNotificationData,
}

export function buildNotificationData(notificationData, variablesForUse = {}) {
  const dataInjector =
    notificationTypesToDataInjectors[notificationData.type] || buildFallBackNotificationData
  return dataInjector(notificationData, variablesForUse)
}
